import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

export const getCompanyByEmailApi = async (cmpEmail, atoken) => {
  const response = await axiosInstance.get(
    `${apiUrl}/api/company_by_email/?companyemail=${cmpEmail}`,
  );

  return response;
};

export const editCompanyByEmailApi = async (
  cmpEmail,
  cmpaddr,
  cmpPhno,
  cmpAvatar,
) => {
  const response = await axiosInstance.put(
    `${apiUrl}/api/edit_company_by_email/${cmpEmail}/`,
    {
      companyaddress: cmpaddr,
      companyphno: cmpPhno,
      companyavatar: cmpAvatar,
    },
  );

  return response;
};
